var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('toolbar',{attrs:{"login":_vm.login,"logout":_vm.logout,"profile":_vm.profile,"loggedIn":_vm.loggedIn,"clientSelection":_vm.client_selection,"client_list":_vm.client_list,"client_selected":_vm.client_selected}}),_vm._v(" "),_c('v-content',[_c('v-container',[_c('router-view')],1)],1),_vm._v(" "),_c('v-footer',{attrs:{"app":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-200d428b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 132
// module chunks = 2